export const API_VERSION = '/v1/ext';

export const API_LANGUAGE = `/languages`;
export const API_STORAGE = '/storages';
export const API_SHOWROOM = '/showrooms';
export const API_PRODUCT = '/products';
export const API_BRAND = '/brands';
export const API_AGENT = '/agents';

export const API_BOT_CHATBOT = '/ext/v1/bots/agents/published';
